import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from "@angular/common/http";
import { catchError, throwError } from "rxjs";
import {inject} from "@angular/core";
import {NavigationExtras, Router} from "@angular/router";

export const HttpErrorInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
) => {
    const router = inject(Router);
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMsg = "";
        let currentUrl = router.routerState.snapshot.url;
        console.log('error in', currentUrl);
        if (error.error instanceof ErrorEvent) {
          console.log("this is client side error");
          errorMsg = `Client Error: ${error.error.message}`;
        } else {
          const navigationExtras: NavigationExtras = { state: { error: error.message } };
          //
          switch (error.status) {
              case 401:
                  if(currentUrl !== '/login') {
                      console.log('redirect to login with back',currentUrl);
                      router.navigate(['/login'], {queryParams: {returnUrl: currentUrl}});
                  }
                  break;
              case 403:
              case 422:
                  // ritorna error anziché errorMsg nel 422. Non ho cambiato generalmente perché non so come vengono gestiti gli errori altrove
                   return throwError(() => error);
              default:
                router.navigate(["/error"], navigationExtras);
                break;
          }
          console.log("this is server side error");
          errorMsg = `Server Error Code: ${error.status}, Message: ${error.message}`;
        }

        console.log(errorMsg);
        return throwError(() => errorMsg);
      }),
  );
};
